import { render, staticRenderFns } from "./actionCompany.vue?vue&type=template&id=3a49659e&"
import script from "./actionCompany.vue?vue&type=script&lang=js&"
export * from "./actionCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports